<div *ngIf="html" [ngClass]="{ 'text': true, 'on-background': onBackground }" [innerHTML]="html"></div>
